import styled from "styled-components"
import {h2} from "@irati/ui/src/Typography/Heading/styles"
import {commonCSS} from "@irati/ui/src/Typography/common"

export default styled.span`
  ${h2}
  ${commonCSS}
`
